import React, {Component} from 'react';
import {Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import DateFormat from "../../../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import ReactNotify from 'react-notify';


export default class KalendarzDoDatyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: null,
            koniec: null,
            validatorMessages: [],
        };
        this.onChangeStart = this.onChangeStart.bind(this)
        this.onChangeKoniec = this.onChangeKoniec.bind(this)
        this.onClickWyswietl = this.onClickWyswietl.bind(this)
        this.onClickGeneruj = this.onClickGeneruj.bind(this)
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops)) {
            this.setState({
                start: moment(nextprops.start),
                koniec: moment(nextprops.koniec)
            })
        }
    }

    componentDidMount() {

        if (Boolean(this.props.start)) {
            this.setState({
                start: moment(this.props.start),
                koniec: moment(this.props.koniec)
            })
        }
    }

    onChangeStart(e) {
        this.setState({start: e})
    }

    onChangeKoniec(e) {
        this.setState({koniec: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickWyswietl() {
        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.start)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty startowej')
        }

        if (!Boolean(this.state.koniec)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty końcowej')
        }

        if (this.state.koniec < this.state.start) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data startowa nie może być późniejsza niż data końcowa')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})
            this.props.handleZakresDat(DateFormat.formatYYYYMMDD(this.state.start), DateFormat.formatYYYYMMDD(this.state.koniec))
        }
    }

    onClickGeneruj() {
        this.props.handleGeneruj();
    }


    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>

                <Form inline={true}>
                    <div>
                        <ControlLabel>
                            Zakres dat od - do
                        </ControlLabel>
                    </div>
                    <FormGroup>
                        <TopInputDate onChange={this.onChangeStart} value={this.state.start}/>
                        <div className={'add-space'}></div>
                        <TopInputDate onChange={this.onChangeKoniec} value={this.state.koniec}/>
                        <div className={'add-space'}></div>
                        <TopButtonAction text={'Wyświetl'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickWyswietl}/>
                        <div className={'add-space'}></div>
                        <TopButtonAction text={'Wygeneruj na nowy okres'} iconType={'fa fa-calendar'} btnSize={'medium'} onClick={this.onClickGeneruj}
                                         btnColor={'warning'} btnDisabled={this.props.generujDisabled}/>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validatorMessages}/>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/components/KalendarzDoDatyForm.js